import { Injectable } from '@angular/core';
import { DataService } from '../data/data.service';
import { HttpService } from '../http/http.service';
import { BehaviorSubject,Observable } from 'rxjs';
import { ILinkPlan, ISearchContractResponse } from '../../interfaces/ISearchContract';
import { ILinkPlanReqBody, ISearchPlanReqBodyByContract, ISearchPlanReqBodyByPhone, ISearchPlanReqBodyByProperty } from '../../interfaces/ISearchPlan';
import { FIND_PLAN_API_URL, getApiUrlForParams, LINK_PLAN_API_URL } from '../../utils/api.util';

@Injectable({
  providedIn: 'root',
})
export class SearchPlanService {
  plans$: BehaviorSubject<ISearchContractResponse[]> = new BehaviorSubject<
    ISearchContractResponse[]
  >([]);
  selectedPlan$: BehaviorSubject<ISearchContractResponse | null> = new BehaviorSubject<
    ISearchContractResponse | null
  >(null);
  selectedPlanMultiple$: BehaviorSubject<ISearchContractResponse[] | null> = new BehaviorSubject<
    ISearchContractResponse[] | null
  >([]);
  constructor(private data: DataService, private http: HttpService) { }
  findContract(reqObj: ISearchPlanReqBodyByPhone | ISearchPlanReqBodyByContract | ISearchPlanReqBodyByProperty): Observable<ISearchContractResponse[]> {
    let auth0Id=this.data.auth0UserId.getValue();
    if(auth0Id)
      reqObj['sub']=auth0Id;
    return this.http.post<ISearchContractResponse[]>(FIND_PLAN_API_URL, reqObj);
  }

  linkPlanToExistingUser(reqObj:ILinkPlanReqBody):Observable<ILinkPlan>{
    const auth0Id=this.data.auth0UserId.getValue();
    return this.http.post<ILinkPlan>(getApiUrlForParams(LINK_PLAN_API_URL, { auth0Id}),reqObj);
  }
}
